import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import {
  Observable,
  switchMap,
  map,
  catchError,
  of,
  take,
} from 'rxjs';
import * as fromResourcesActions from '../actions/resources.actions';

import { Firestore, collection, doc, query, where } from '@angular/fire/firestore';
import { ResourceFirebaseResponse } from '../../models/resources.model';
import { FirebaseService } from '../../services/firebase/firebase.service';

@Injectable()
export class ResourcesEffects {
  constructor(
    private readonly action$: Actions,
    private readonly firestore: Firestore,
    private readonly firebaseService: FirebaseService,
  ) {}

  // Load Resources
  loadResources$: Observable<Action> = createEffect(() =>
    this.action$.pipe(
      ofType(fromResourcesActions.LoadResourcesAction),
      switchMap(({ user }) => {
        const trainer = doc(this.firestore, `users/${user.trainerId}`);

        const ref = query(
            collection(this.firestore, 'resources'),
            where('trainerRef', '==', trainer)
        );
        return this.firebaseService.getDataOfCollectionByField(ref).pipe(take(1), map((resp) => resp.map((doc) => {
            const resp = doc as ResourceFirebaseResponse;
            delete resp.trainerRef;
            return resp;
        })));
      }),
      map((data) => ({
        type: fromResourcesActions.LOAD_RESOURCES_SUCCESS,
        data
      })),
      catchError((error) =>
        of({
          type: fromResourcesActions.LOAD_RESOURCES_FAIL,
          error: error
        })
      )
    )
  );
}
